// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"261":"d0a62a61","652":"2732b402","728":"658697f8","948":"aca4baac"}[chunkId] + ".chunk.js";
};